export default "__VITE_ASSET__DxM5qsTZ__"